// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productPriceAndActionsStyle } from "@ces/App/Components/Product/ProductPriceAndActions";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            border: none;
            padding: 0;
        `,
    },
};

productPriceAndActionsStyle.badgesWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        height: 24px;
        margin-bottom: 12px;
    `,
};
productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    compareCheckbox: {
        css: css`
            padding-top: 0;
            margin: 0;
        `,
    },
};

productPriceAndActionsStyle.productPriceStyles = {
    quoteMessage: {
        text: {
            size: "18px",
            lineHeight: "22px",
            weight: fontConfig.weight.bold,
        },
        tooltip: {
            mergeCss: true,
            cssOverrides: {
                tooltipWrapper: css`
                    height: 22px;
                `,
            },
        },
    },
};
